import { graphqlApiClient } from '../client';
import { MetaObjectField } from '../types';
import { MASTER_QUERY, MasterQueryResponse } from './query';
import { Master } from './types';

export const EMPTY_COUPONS: Master['distributeCoupons'] = [];
export const EMPTY_STRING_ARRAY: string[] = [];

export async function fetchGraphqlMaster() {
  try {
    const result = await graphqlApiClient<MasterQueryResponse>(MASTER_QUERY);

    const fields = result.metaobjects.nodes[0].fields;
    if (!fields) return null;

    return parsedMaster(fields);
  } catch (error) {
    console.log(error);
    return null;
  }
}

function parsedMaster(data: MetaObjectField[]): Master {
  const fieldMap: Record<string, string> = Object.create(null);
  for (let i = 0; i < data.length; i++) {
    const f = data[i];
    if (f.value != null) {
      fieldMap[f.key] = f.value;
    }
  }

  const parsedSettings = safeParse(fieldMap['settings'], null);

  return {
    categories: safeParse(fieldMap['categories_2'], null),
    recommendedSets: safeParse(fieldMap['recommended_set'], null),
    settings: parsedSettings?.['general'] ?? null,
    distributeCoupons: safeParse(fieldMap['distribute_coupons'], EMPTY_COUPONS),
    excludeDates: safeParse(fieldMap['exclude_dates'], EMPTY_STRING_ARRAY),
    boxSettings: safeParse(fieldMap['box_settings'], null),
  };
}

function safeParse<T>(value: string | undefined, fallback: T): T {
  if (!value) return fallback;

  try {
    return JSON.parse(value);
  } catch {
    return fallback;
  }
}
